/* eslint max-len:0 */
import template from './refineDistributions.html';
import mori from 'mori';
import stateGo from 'redux-ui-router/lib/state-go';

export default function() {
  return {
    scope: {},
    templateUrl: template,
    controller: Controller,
    controllerAs: 'distributions',
    bindToController: {
      locked: '=',
    },
  };
}

Controller.$inject = ['$scope', '$attrs', '$filter', '$ngRedux'];
function Controller($scope, $attrs, $filter, $ngRedux) {
  this.$ngRedux = $ngRedux;

  const disconnect = $ngRedux.connect((state) => {
    return {
      router: state.router,
      sheet: state.data,
    };
  })(this);

  $scope.$on('$destroy', disconnect);

  const loadDistributions = $scope.$watch(
    () => mori.hash(this.sheet.immutableDistributions),
    (val) => {
      // Zero hash means it was null
      if (val !== 0) {
        const metaTimeframe =
          this.sheet.timeframes[this.router.currentParams.currentTimeframe];
        this.distributions = mori.toJs(
          this.sheet.metaData ?
            this.sheet.metaData[metaTimeframe].immutableDistributions :
            this.sheet.immutableDistributions
        );
        this.buildItems(this.router.currentParams.selectedDistributions);
        // Remove self after firing
        loadDistributions();
      }
    }
  );

  // reset distributions if timeframe changes
  $scope.$watch(
    () => this.router.currentParams.currentTimeframe,
    (newval, oldval) => {
      // don't update if no change
      // don't update if no timeframes defined
      if ((newval === oldval &&
        this.router.currentParams.selectedDistributions) ||
        !this.sheet.timeframes || !this.sheet.metaData
      ) {
        return;
      }

      this.clearSelectedDistributions();
      const metaTimeframe =
        this.sheet.timeframes[this.router.currentParams.currentTimeframe];
      this.distributions =
        mori.toJs(this.sheet.metaData[metaTimeframe].immutableDistributions);
      this.items = null;
      this.buildItems(this.router.currentParams.selectedDistributions);
      if (this.router.currentParams.activeTab === 'map' || (
        this.router.currentParams.activeTab === 'graph' && this.locked
      )) {
        $ngRedux.dispatch(stateGo('datacenter.main', {
          selectedDistributions:
            this.getFirstAvailableDistribution(newval).slug ||
            this.distributions[0].slug,
        }));
      }
    }
  );

  // reset selections on table view for locked indicators
  $scope.$watch(
    () => this.router.currentParams.activeTab,
    (newval, oldval) => {
      // don't update if no change
      if (newval === oldval &&
        this.router.currentParams.selectedDistributions
      ) {
        return;
      }
      // clear selections in table view when coming from another tab
      if (newval === undefined && oldval !== undefined && this.locked) {
        this.clearSelectedDistributions();
      // select first available when radio buttons are in use
      } else if (newval === 'map' || (newval === 'graph' && this.locked)) {
        $ngRedux.dispatch(stateGo('datacenter.main', {
          selectedDistributions:
            this.getFirstAvailableDistribution(newval).slug ||
            this.distributions[0].slug,
        }));
      }
    }
  );

  // Hide items which should be shown for map
  // @TODO share this with exclude for graph
  $scope.$watch(
    () => this.router.currentParams.selectedDistributions,
    this.buildItems.bind(this)
  );
}

Controller.prototype.isRadioSelected = function() {
  return this.router.currentParams.activeTab === 'map' ||
    (this.locked && this.router.currentParams.activeTab === 'graph');
};

Controller.prototype.getFirstAvailableDistribution = function(view) {
  const included = mori.filter(
    (item) => item.exclude.indexOf(view) === -1 || view === 'table',
    this.items
  );

  return mori.first(
    mori.filter((item) => item.selected, included)
  ) || mori.first(included);
};

Controller.prototype.clearSelectedDistributions = function() {
  this.$ngRedux.dispatch(stateGo('datacenter.main', {
    selectedDistributions: undefined,
  }));
};

// update when a checkbox item is selected
Controller.prototype.checkboxUpdate = function() {
  const selected = this.items
    .filter((item) => item.selected)
    .map((item) => item.slug);

  this.$ngRedux.dispatch(stateGo('datacenter.main', {
    selectedDistributions: selected.join('--'),
  }));
};

// update when the selected radio changes. will trigger the watch on items
Controller.prototype.updateRadio = function(slug) {
  this.$ngRedux.dispatch(stateGo('datacenter.main', {
    selectedDistributions: slug,
  }));
};

Controller.prototype.buildItems = function(selectedDistributions) {
  if (!this.items) {
    this.items = this.distributions;
  }

  this.items = this.items && this.items.map(
    (item) => angular.extend({}, item, {
      selected: []
        .concat((selectedDistributions || '').split('--'))
        .indexOf(item.slug) > -1,
    })
  );
};



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/directives/refineDistributions/refineDistributions.js